/**
 * Describes the type of issuer signature
 */
enum SignatureType {
  ECDSA = 'ecdsa',
  BABYJUBJUB = 'babyJubJub',
}

export default SignatureType;
